export const Home = () => {
  return <>Authorized user home page</>;
};
